require('../css/statics.css');